<template lang="pug"></template>

<script>
export default {
    name: 'BotaoInteligenciaCarbono',
    componentOptions: {
        title: 'Inteligência Carbono',
        actions: [
            [
                {
                    name: 'Inteligência Carbono',
                    iconClass: 'lyra-icon lyra-ia',
                    showView: false,
                    action: 'abrirInteligencia',
                    route: 'InteligenciaCarbono',
                    nameTranslationKey:
                        'mensagens.menuLateral.inteligenciaCarbono'
                }
            ]
        ]
    },

    methods: {
        abrirInteligencia() {
            if (this.$route.name !== 'InteligenciaCarbono') {
                this.$router.push({ name: 'InteligenciaCarbono' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
